var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c("div", { staticClass: "panel-body" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.products.length > 0
          ? _c("div", { staticClass: "total-longterms" }, [
              _c("div", [
                _vm._v("FBA長期在庫追加手数料の対象になる商品があります")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flexbox gap-20 mr-t-10",
                  staticStyle: { "align-items": "stretch" }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "est-longterm" }, [
                    _c("div", [
                      _vm._v("長期在庫追加手数料（次回Amazon請求の見積）")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c("span", { staticClass: "text-size-28" }, [
                        _vm._v(_vm._s(_vm.formatNumber(this.totalEstimated)))
                      ]),
                      _vm._v(" 円\n        ")
                    ])
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm.products.length > 0
          ? _c(
              "div",
              { staticClass: "fba-longterm-table" },
              [
                _vm.cantViewContent ? _c("premium-modal") : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "text-gray text-right" }, [
                  _vm._v(
                    "\n      基準日：" +
                      _vm._s(_vm.products[0].snapshotDate) +
                      "\n    "
                  )
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "full-width bg-white mr-t-10" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.products, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { staticClass: "product-info" }, [
                          _c("div", { staticClass: "flexbox gap-10 no-wrap" }, [
                            item.image
                              ? _c("img", {
                                  staticClass: "w-80",
                                  attrs: { src: item.image, alt: "" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "tooltip-wrapper" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "text--underline product-name",
                                    attrs: {
                                      href:
                                        "https://www.amazon.co.jp/gp/offer-listing/" +
                                        item.asin,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.sliceProductName(item.productName)
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "tooltip-text" }, [
                                  _vm._v(_vm._s(item.productName))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flexbox gap-20" }, [
                                _c("div", [
                                  _c("span", { staticClass: "text-gray" }, [
                                    _vm._v("SKU：")
                                  ]),
                                  _vm._v(" "),
                                  _c("b", [_vm._v(_vm._s(item.sku))])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "text-gray" }, [
                                    _vm._v("ASIN：")
                                  ]),
                                  _vm._v(" "),
                                  _c("b", [_vm._v(_vm._s(item.asin))])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "text-gray" }, [
                                    _vm._v("FNSKU：")
                                  ]),
                                  _vm._v(" "),
                                  _c("b", [_vm._v(_vm._s(item.fnsku))])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "fee" }, [
                          _c(
                            "div",
                            { staticClass: "flexbox justify-right gap-20" },
                            [
                              _c("div", [
                                _c("span", { staticClass: "text-size-28" }, [
                                  _vm._v(
                                    _vm._s(_vm.formatNumber(item.totalQuantity))
                                  )
                                ]),
                                _vm._v(" 個\n              ")
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary w-100 text-size-20",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "collapse",
                                    "data-target": "#" + _vm.getItemId(item)
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.handleExpand($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                内訳\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "fa fa-chevron-down",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse fee-data",
                              attrs: { id: _vm.getItemId(item) }
                            },
                            _vm._l(item.quantity, function(value, title, i) {
                              return _c(
                                "div",
                                { key: i, staticClass: "fee-item" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(title) +
                                      "：\n                "
                                  ),
                                  _c("span", { staticClass: "text-green" }, [
                                    _vm._v(_vm._s(_vm.formatNumber(value)))
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "est-fee" }, [
                          _c(
                            "span",
                            { staticClass: "text-size-28 font-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.formatNumber(item.totalEstimate))
                              )
                            ]
                          ),
                          _vm._v(" 円\n          ")
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-size-20" }, [
      _vm._v(
        "\n    AmazonのFBA倉庫に長期的に保管されている在庫に対して発生する「長期在庫追加手数料」の対象となる商品情報です。"
      ),
      _c("br"),
      _vm._v("\n    毎月5日、20日時点の在庫状況により計算します。\n  ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flexbox storage-fee text-gray bg-white" },
      [_c("span", [_vm._v("在庫保管手数料")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flexbox" }, [
      _c("i", {
        staticClass: "fa fa-plus text-gray",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fba-longterm-banner" }, [
      _c("div", { staticClass: "fba-longterm-icon" }),
      _vm._v(" "),
      _c("fieldset", [
        _c("legend", [_vm._v("注目!")]),
        _vm._v(" "),
        _c("div", { staticClass: "fba-longterm-content" }, [
          _vm._v("\n        手数料を削減できる可能性があります\n      ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "product-info" }, [_vm._v("商品情報")]),
        _vm._v(" "),
        _c("th", { staticClass: "fee" }, [
          _vm._v("\n            次回請求における"),
          _c("br"),
          _vm._v("\n            長期在庫追加手数料の対象商品数\n          ")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "est-fee" }, [
          _vm._v("\n            次回請求における"),
          _c("br"),
          _vm._v("\n            長期在庫追加手数料の見積\n          ")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf7f17c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf7f17c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/salemonAgent/LongtermStock.vue
// module id = null
// module chunks = 